export default "__VITE_ASSET__XOAm15XX__"